import {withStyles} from "material-ui";
import React, {Fragment, useEffect, useLayoutEffect} from "react";
import {connect} from "react-redux";
import styles from "./styles";
import "./index.css";

import SortableTreeWithoutDndContext, {
  getTreeFromFlatData,
  changeNodeAtPath,
  getNodeAtPath,
  insertNode,
  removeNodeAtPath,
  addNodeUnderParent,
  find,
  getVisibleNodeInfoAtIndex
} from 'react-sortable-tree';
import theme from './theme.js'
import 'react-sortable-tree/style.css';

import "react-contexify/dist/ReactContexify.min.css";
import {contextMenu} from "react-contexify";
import {Menu, Item, Submenu} from "react-contexify";
import {
  treeview,
  treeviewChange,
  moveTestInTree,
  treeviewNewNode,
  treeviewRemoveNode,
  nodeExpanded,
  nodeRenamed,
  nodeMovedToVault,
  nodeMoved,
  getNodeNote,
  addNodeNote,
  jobOrderChange,
  treeviewNotifyError,
  nodeIncludeLowerRecords,
  lowerRecordsChecked,
  setSelectedNode,
  setNodeIds,
  treeviewEditJobSet
} from "../../redux/actions/treeviewActions";
import {
  getJobTreeview,
  resetJobTreeview,
  exportJobTreeview
} from "../../redux/actions";
import history from "../../history";
import NodeNameModal from "./nodeNameModal";
import DeleteConfirmationModal from "./deleteConfirmationModal";
import NotesModal from "./notesModal";
import ErrorBoundary from "./errorBoundary";
import {isSignalTEK10GType, getTreeviewNodeCategory} from '../../common/utils'

var selectedItem = [];

const TreeView = (props) => {
  const showAddJob = props.showAddJob;
  const showReportFromTreeview = props.showReportModal;
  const translate = props.translate;
  const jobs = props.jobs;
  const job = props.job;
  const jobTreeview = props.jobTreeview;
  const treeData = props.treeData;
  const refresh = props.refreshTest;
  const selectedCustomerId = props.selectedCustomerId;
  const originalNote = props.originalNote;
  const nodeNameSelected = props.nodeNameSelected;
  const tests = props.tests;
  const testsCreated = props.testsCreated;
  const testUpdated = props.testUpdated;
  const testListOf10g = props.testListOf10g;
  const jobsOrder = props.jobsOrder;
  const jobDeleted = props.jobDeleted;
  const resetTestCount = props.resetTestCount;

  const [currentNode, setCurrentNode] = React.useState({});
  const [path, setPath] = React.useState(null);
  const [verbosePath, setVerbosePath] = React.useState(null);
  const [showModal, showHideNodeModal] = React.useState(false);
  const [showConfirmationModal, showHideConfirmationModal] = React.useState(false);
  const [showNoteModal, showHideNotesModal] = React.useState(false);
  const [modalTitle, setModalTitle] = React.useState('');
  const [modalType, setModalType] = React.useState('');
  const [treeNode, setTreeNode] = React.useState({});
  const [nodeType, setNodeType] = React.useState('');
  const [nodeToDelete, setNodeToDelete] = React.useState('');
  const [nodeId, setNodeId] = React.useState('');
  const [nodeName, setNodeName] = React.useState('');
  const showNodeModal = () => showHideNodeModal(true);
  const showDeleteConfirmationModal = () => showHideConfirmationModal(true);
  const showNotesModal = () => showHideNotesModal(true);
  const [searchQuery, setSearchQuery] = React.useState('');

  if (treeData && Array.isArray(treeData)) {
    var jobsNode = treeData.find((n) => {
      return n.type === "jobs";
    });

    if (jobsNode) {
      jobsNode.title = translate("general_jobs");
    }

    var vaultNode = treeData.find((n) => {
      return n.type === "vault";
    });

    if (vaultNode) {
      vaultNode.title = translate("archive");
    }
  }

  function handleNodeNameClose(name) {

    if (name && name.trim() === '') {
      return;
    }

    if (treeNode.node.children) {
      var nodes = treeNode.node.children.filter((node) => node.type === nodeType);
      if (nodes) {
        var nodesWithSameName = nodes.find(x => x.title.toLowerCase() === name.toLowerCase());
        if (nodesWithSameName) {
          props.notifyError("test_duplicate_error_desc");
          return;
        }
      }
    }

    /*if (treeNode.parentNode.children) {
      var nodes = treeNode.parentNode.children.filter((node) => node.type === nodeType);
      if (nodes) {
        var nodesWithSameName = nodes.find(x => x.title.toLowerCase() === name.toLowerCase());
        if (nodesWithSameName) {
          props.notifyError("test_duplicate_error_desc");
          return;
        }
      }
    }*/

    if (modalType === 'add') {
      insertNewNode(treeNode, name, nodeType);
    }

    if (modalType === 'rename') {
      changeNode(treeNode, name);
    }
  }

  function handleConfirmationClose() {
    removeNode(treeNode);
  }

  function handleNotesClose(note) {
    props.addNodeNote(nodeId, note);
  }

  var Modal = () => {
    return <NodeNameModal translate={translate} title={modalTitle}
                          isOpen={showModal}
                          showHideNodeModal={showHideNodeModal}
                          onNodeNameClose={handleNodeNameClose}
                          nodeType={nodeType}/>
  };

  var ConfirmationModal = () => {
    return <DeleteConfirmationModal translate={translate}
                                    nodeToDelete={nodeToDelete}
                                    isOpen={showConfirmationModal}
                                    showHideConfirmationModal={showHideConfirmationModal}
                                    onConfirmationClose={handleConfirmationClose}/>
  };

  var NoteModal = () => {
    return <NotesModal translate={translate} originalNote={originalNote}
                       nodeName={nodeName} isOpen={showNoteModal}
                       showHideNotesModal={showHideNotesModal}
                       onNotesClose={handleNotesClose}/>
  };

  const isMenuItemDisabledForJob = (selectedItem) => {
    if (!selectedItem.parentNode && showAddJob) {
      return false;
    }

    if (selectedItem.node.type === 'jobs' && showAddJob) {
      return false;
    }

    return true;
  }

  const isMenuItemDisabledForBuilding = (selectedItem) => {

    if (selectedItem.node.type === 'jobs' || selectedItem.node.type === 'vault') {
      return true;
    }

    if (selectedItem.parentNode.type === 'jobs' && selectedItem.node.type === 'job') {
      return false;
    }

    if (!selectedItem.parentNode) {
      return false;
    }

    if (selectedItem.parentNode.type === 'jobs' && selectedItem.node.type !== 'building') {
      return false;
    }

    return true;
  }

  const isMenuItemDisabledForFloor = (selectedItem) => {

    if (selectedItem.node.type === 'jobs' || selectedItem.node.type === 'vault') {
      return true;
    }

    if (!selectedItem.parentNode) {
      return false;
    }

    if (selectedItem.node.type === 'job') {
      return false;
    }

    if (selectedItem.node.type === 'building') {
      return false;
    }

    if (selectedItem.node.type === 'floor') {
      return true;
    }

    return true;
  }

  const isMenuItemDisabledForRoom = (selectedItem) => {

    if (selectedItem.node.type === 'jobs' || selectedItem.node.type === 'vault') {
      return true;
    }

    if (!selectedItem.parentNode) {
      return false;
    }

    if (selectedItem.node.type === 'job') {
      return false;
    }

    if (selectedItem.node.type === 'building') {
      return false;
    }

    if (selectedItem.node.type === 'floor') {
      return false;
    }

    return true;
  }

  const isMenuItemDisabledForRack = (selectedItem) => {

    if (selectedItem.node.type === 'jobs' || selectedItem.node.type === 'vault') {
      return true;
    }

    if (!selectedItem.parentNode) {
      return false;
    }

    if (selectedItem.node.type === 'job') {
      return false;
    }

    if (selectedItem.node.type === 'building') {
      return false;
    }

    if (selectedItem.node.type === 'floor') {
      return false;
    }

    if (selectedItem.node.type === 'room') {
      return false;
    }

    return true;
  }

  const isMenuItemDisabledForPanel = (selectedItem) => {

    if (selectedItem.node.type === 'jobs' || selectedItem.node.type === 'vault') {
      return true;
    }

    if (selectedItem.node.type === 'panel') {
      return true;
    }

    return false;
  }

  const isMenuItemDisabledForOrphan = (selectedItem) => {

    if (selectedItem.node.type === 'jobs' || selectedItem.node.type === 'vault') {
      return true;
    }

    return selectedItem.node.isOrphan;
  }

  const isMenuItemDisabledForProperties = (selectedItem) => {

    if (selectedItem.node.type === 'jobs' || selectedItem.node.type === 'vault') {
      return true;
    }

    return false;
  }

  const isMenuItemDisabledForEdit = (selectedItem) => {

    if ((selectedItem.node.type === 'job') && showAddJob) {
      return false;
    }

    return true;
  }

  const isMenuItemDisabledForDownload = (selectedItem) => {
    if (selectedItem.node.testType === 'comet_copper' || selectedItem.node.testType === 'comet_fiber') {
      return false;
    }

    return true;
  }

  const isRenameDeleteDisabled = (selectedItem) => {
    if (!selectedItem.parentNode) {
      return true;
    }

    return false;
  }

  var DefaultContextMenu = ({menuId, chooseAction}) => {
    return <Menu id={menuId}>
      <Submenu label={translate("tooltip_add")}>
        <Item disabled={() => isMenuItemDisabledForJob(selectedItem)}
              onClick={() => chooseAction(selectedItem, "add", "job")}>{translate("general_job")}</Item>
        <Item disabled={() => isMenuItemDisabledForBuilding(selectedItem)}
              onClick={() => chooseAction(selectedItem, "add", "building")}>{translate("building")}</Item>
        <Item disabled={() => isMenuItemDisabledForFloor(selectedItem)}
              onClick={() => chooseAction(selectedItem, "add", "floor")}>{translate("floor")}</Item>
        <Item disabled={() => isMenuItemDisabledForRoom(selectedItem)}
              onClick={() => chooseAction(selectedItem, "add", "room")}>{translate("room")}</Item>
        <Item disabled={() => isMenuItemDisabledForRack(selectedItem)}
              onClick={() => chooseAction(selectedItem, "add", "rack")}>{translate("rack")}</Item>
        <Item disabled={() => isMenuItemDisabledForPanel(selectedItem)}
              onClick={() => chooseAction(selectedItem, "add", "panel")}>{translate("panel")}</Item>
      </Submenu>
      <Item disabled={() => isRenameDeleteDisabled(selectedItem)}
            onClick={() => chooseAction(selectedItem, "rename")}>{translate("rename")}</Item>
      <Item disabled={() => isRenameDeleteDisabled(selectedItem)}
            onClick={() => chooseAction(selectedItem, "delete")}>{translate("delete")}</Item>
      <Item disabled={() => isMenuItemDisabledForEdit(selectedItem)}
            onClick={() => chooseAction(selectedItem, "edit")}>{translate("general_edit")}</Item>
      <Item disabled={() => isMenuItemDisabledForProperties(selectedItem)}
            onClick={() => chooseAction(selectedItem, "properties")}>{translate("properties")}</Item>
      <Item disabled={() => isMenuItemDisabledForDownload(selectedItem)}
            onClick={() => chooseAction(selectedItem, "download")}>{translate("download_job") + " (ZIP)"}</Item>
      <Item disabled={() => isMenuItemDisabledForDownload(selectedItem)}
            onClick={() => chooseAction(selectedItem, "exportCSV")}>{translate("download_job") + " (CSV)"}</Item>
      <Item disabled={() => isMenuItemDisabledForOrphan(selectedItem)}
            onClick={() => chooseAction(selectedItem, "report")}>{translate("tooltip_create_report")}</Item>
      <Item disabled={() => isMenuItemDisabledForOrphan(selectedItem)}
            onClick={() => chooseAction(selectedItem, "includeLower")}>
        <input type="checkbox" id="lowerRecords" name="incLowerRecs"
               data={props.key}
               onChange={() => chooseAction(selectedItem, "checkboxToggle")}/>
        {translate("lowerlevels")}
      </Item>
      <Item disabled={() => isMenuItemDisabledForJob(selectedItem)}
            onClick={() => chooseAction(selectedItem, "reload")}>{translate("tooltip_reload")}</Item>
    </Menu>
  };

  const chooseAction = (treeData, type, detail) => {

    if (type === "reload") {
      props.start('all', -1);
      return;
    }

    if (type === "add") {
      setTreeNode(treeData);
      setNodeType(detail);

      if (detail === "job") {
        var createJobButton = document.getElementById("create-job");
        if (createJobButton) {
          createJobButton.click();
        }
      } else {
        setModalTitle(translate("newitem"));
        setModalType('add');
        showNodeModal();
      }
    }

    if (type === "duplicate") {
      this.duplicateNode(treeData);
    }

    if (type === "edit") {
      props.treeviewEditJobSet(treeData.node.jobId);
    }

    if (type === "rename") {
      setTreeNode(treeData);
      setNodeType(treeData.node.type);
      setModalTitle(translate("newname"));
      setModalType('rename');
      showNodeModal();
    }

    if (type === "delete") {
      setTreeNode(treeData);
      setNodeToDelete(treeData.node.title);
      showDeleteConfirmationModal();
    }

    if (type === "checkboxToggle") {
      var checkbox = document.getElementById('lowerRecords');

      if (checkbox) {
        localStorage.setItem("lower-levels", checkbox.checked);
      }
    }

    if (type === "properties") {
      setNodeId(treeData.node.id);
      setNodeName(treeData.node.title);
      props.getNodeNote(treeData.node.id);
      setTimeout(() => {
        showNotesModal();
      }, 500);
    }

    if (type === "report") {
      var includeLowerRecords = true;
      var checkbox = document.getElementById('lowerRecords');

      if (checkbox) {
        includeLowerRecords = checkbox.checked;
      }

      props.getReportJob(treeData.node.jobId, treeData.node.id, includeLowerRecords);
    }

    if (type === "download" || type === "exportCSV") {
      var includeLowerRecords = true;
      var checkbox = document.getElementById('lowerRecords');
      var csvExport = (type === "exportCSV") ? true : false;

      if (checkbox) {
        includeLowerRecords = checkbox.checked;
      }

      props.exportJob(treeData.node.jobId, treeData.node.id, includeLowerRecords, csvExport);
    }
  }

  useEffect(() => {

    if (jobDeleted) {
      var selectedNode = [];
      var selectedNodeId = '';

      if (treeData) {
        selectedNode = getSelectedNode();

        if (selectedNode) {
          selectedNodeId = selectedNode.id;
        }
      }

      var customerId = selectedCustomerId;
      if (typeof customerId === "undefined") {
        customerId = -1;
      }

      const t = setTimeout(() => {
        props.start(selectedNodeId, customerId);
      }, 1500);
      return () => clearTimeout(t);
    }
  }, [jobDeleted]);

  useEffect(() => {
    if ((tests && tests.data) || treeData || jobsOrder || selectedCustomerId || job) {
      const t = setTimeout(() => {
        var selectedNode = [];
        var selectedNodeId = '';

        if (treeData) {
          selectedNode = getSelectedNode();

          if (selectedNode) {
            selectedNodeId = selectedNode.id;
          }
        }

        var customerId = selectedCustomerId;
        if (typeof customerId === "undefined") {
          customerId = -1;
        }

        if (jobsOrder) {
          props.jobOrderChange(jobsOrder.field, jobsOrder.sorttype, selectedNodeId, customerId);
        } else {
          return () => {
            if (job && job.uniqueId !== selectedNode.topParentId) {
              props.start(job.uniqueId, customerId);
            } else {
              props.start(selectedNodeId, customerId);
            }
          }
        }
      }, 500);
      return () => clearTimeout(t);
    }
  }, [tests, selectedCustomerId, jobsOrder, job]);

  useEffect(() => {
    if (testsCreated === true || testUpdated === true || testListOf10g) {

      var selectedNode = [];
      var selectedNodeId = '';

      if (selectedNode) {
        selectedNodeId = selectedNode.id;
      }

      props.start(selectedNodeId, -1);
    }
  }, [testsCreated, testUpdated, testListOf10g]);


  useLayoutEffect(() => {
    const selected = getSelectedNodes();
    const t = setTimeout(() => {
      if (job && selected.length > 0) {
        setSearchQuery({
          nodeId: selected[0].id
        });
      }
    }, 0);
    return () => clearTimeout(t);
  }, [job, treeData]);

  useEffect(() => {

    // default the include lower levels checkbox to true on load
    var lowerLevels = localStorage.getItem("lower-levels");

    if (lowerLevels !== "false" && lowerLevels !== "true") {
      const t = setTimeout(() => {
        var checkbox = document.getElementById('lowerRecords');

        if (checkbox) {
          checkbox.checked = true;
        }
      }, 100);
      return () => clearTimeout(t);
    }
  }, [treeData]);

  useEffect(() => {
    if (jobTreeview) {

      showReportFromTreeview(jobTreeview);

      // clean up the job for the reports which will set it back to null
      return () => {
        props.resetJobTreeview();
      };
    }
  }, [jobTreeview]);

  const getSelectedNode = () => {
    var selectedNode = [];

    if (treeData && treeData.length > 0) {

      treeData.forEach(node => {
        if (node.selected) {
          selectedNode = node;
        }

        if (node.children) {
          node.children.forEach(lvl1 => {
            if (lvl1.selected) {
              selectedNode = lvl1;
              selectedNode.topParentId = lvl1.id;
            }

            if (lvl1.children) {
              lvl1.children.forEach(lvl2 => {
                if (lvl2.selected) {
                  selectedNode = lvl2;
                  selectedNode.topParentId = lvl1.id;
                }

                if (lvl2.children) {
                  lvl2.children.forEach(lvl3 => {
                    if (lvl3.selected) {
                      selectedNode = lvl3;
                      selectedNode.topParentId = lvl1.id;
                    }

                    if (lvl3.children) {
                      lvl3.children.forEach(lvl4 => {
                        if (lvl4.selected) {
                          selectedNode = lvl4;
                          selectedNode.topParentId = lvl1.id;
                        }

                        if (lvl4.children) {
                          lvl4.children.forEach(lvl5 => {
                            if (lvl5.selected) {
                              selectedNode = lvl5;
                              selectedNode.topParentId = lvl1.id;
                            }

                            if (lvl5.children) {
                              lvl5.children.forEach(lvl6 => {
                                if (lvl6.selected) {
                                  selectedNode = lvl6;
                                  selectedNode.topParentId = lvl1.id;
                                }

                                if (lvl6.children) {
                                  lvl6.children.forEach(lvl7 => {
                                    if (lvl7.selected) {
                                      selectedNode = lvl7;
                                      selectedNode.topParentId = lvl1.id;
                                    }
                                  });
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    }

    return selectedNode;
  }

  const getSelectedNodeId = () => {
    var selectedNode = [];
    var selectedNodeId = '-1';

    if (treeData) {
      selectedNode = getSelectedNode();

      if (selectedNode) {
        selectedNodeId = selectedNode.id;
      }
    }
    return selectedNodeId;
  }
  // Copy of method above, to not mutate state, jut get currently selected nodes
  const getSelectedNodes = () => {
    const selectedNodes = [];

    if (treeData && treeData.length > 0) {

      treeData.forEach(node => {
        if (node.selected) {
          selectedNodes.push(node);
        }

        if (node.children) {
          node.children.forEach(lvl1 => {
            if (lvl1.selected) {
              selectedNodes.push(lvl1);
              // selectedNode.topParentId = lvl1.id;
            }

            if (lvl1.children) {
              lvl1.children.forEach(lvl2 => {
                if (lvl2.selected) {
                  selectedNodes.push(lvl2);
                  // selectedNode.topParentId = lvl1.id;
                }

                if (lvl2.children) {
                  lvl2.children.forEach(lvl3 => {
                    if (lvl3.selected) {
                      selectedNodes.push(lvl3);
                      // selectedNode.topParentId = lvl1.id;
                    }

                    if (lvl3.children) {
                      lvl3.children.forEach(lvl4 => {
                        if (lvl4.selected) {
                          selectedNodes.push(lvl4);
                          // selectedNode.topParentId = lvl1.id;
                        }

                        if (lvl4.children) {
                          lvl4.children.forEach(lvl5 => {
                            if (lvl5.selected) {
                              selectedNodes.push(lvl5);
                              // selectedNode.topParentId = lvl1.id;
                            }

                            if (lvl5.children) {
                              lvl5.children.forEach(lvl6 => {
                                if (lvl6.selected) {
                                  selectedNodes.push(lvl6);
                                  // selectedNode.topParentId = lvl1.id;
                                }

                                if (lvl6.children) {
                                  lvl6.children.forEach(lvl7 => {
                                    if (lvl7.selected) {
                                      selectedNodes.push(lvl7);
                                      // selectedNode.topParentId = lvl1.id;
                                    }
                                  });
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    }

    return selectedNodes;
  }

  const insertNewNode = (rowInfo, title, type) => {
    var parentId = rowInfo.node.id;
    var jobId = rowInfo.node.jobId;

    let {path} = rowInfo;

    let currentNode = getNodeAtPath({
      treeData: treeData,
      path: path,
      getNodeKey: ({treeIndex}) => treeIndex,
      ignoreCollapsed: true
    });

    let getNodeKey = ({node: object, treeIndex: number}) => {

      return number;
    };

    let parentKey = getNodeKey(currentNode);
    if (parentKey === -1) {
      parentKey = null;
    }
    const newNodeData = addNodeUnderParent({
      treeData: treeData,
      parentKey: parentKey,
      expandParent: true,
      newNode: {title: title, type: type, children: []},
      getNodeKey: ({treeIndex}) => treeIndex
    });

    props.addNodeToTree(parentId, title, type, jobId, getSelectedNodeId());
  }

  const removeNode = (selectedNode) => {
    if (selectedNode.node) {
      props.removeNode(selectedNode.node.id, selectedNode.node.jobId, selectedNode.node.type === 'job');
      setTimeout(() => {
        var customerId = selectedCustomerId;
        if (typeof customerId === "undefined") {
          customerId = -1;
        }

        if (selectedNode.node.type === 'job') {
          history.push('/jobs');
        }

        handleRefresh();
      }, 500);
    }
  }

  const setSelectedTreeNode = (n) => {
    treeData.forEach(node => {
      node.selected = false;

      if (node.children) {
        node.children.forEach(lvl1 => {
          lvl1.selected = false;

          if (lvl1.children) {
            lvl1.children.forEach(lvl2 => {
              lvl2.selected = false;

              if (lvl2.children) {
                lvl2.children.forEach(lvl3 => {
                  lvl3.selected = false;

                  if (lvl3.children) {
                    lvl3.children.forEach(lvl4 => {
                      lvl4.selected = false;

                      if (lvl4.children) {
                        lvl4.children.forEach(lvl5 => {
                          lvl5.selected = false;

                          if (lvl5.children) {
                            lvl5.children.forEach(lvl6 => {
                              lvl6.selected = false;

                              if (lvl6.children) {
                                lvl6.children.forEach(lvl7 => {
                                  lvl7.selected = false;
                                });
                              }
                            });
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });

    n.selected = true;
  }

  const selectThis = (node, path) => {

    if (node.type !== 'jobs') {
      props.persistSelectedNode(node.id);
      props.setNodeIds(node.id);
    }

    setSelectedTreeNode(node);

    if (node.type === 'vault') {
      return;
    }

    if (node.type === 'jobs') {
      history.push('/jobs');
      return;
    }

    var treeRootNode = getVisibleNodeInfoAtIndex({
      treeData: treeData,
      index: path[0],
      getNodeKey: (node) => {
        node.treeIndex
      }
    });
    var jobId = treeRootNode.node.jobId;

    if (jobId === 0) {
      jobId = node.jobId;
    }

    props.treeChange(treeData);

    setTimeout(() => {
      setCurrentNode(node, setPath(path, handlePassSelectedPath(convertPathToVerbose(node, path), jobId, node.customerId)));
    }, 200);
  }

  const convertPathToVerbose = (node, path) => {
    var verbosePath = '';
    const getNodeKey = (node) => {
      node.treeIndex
    };
    for (let step in path) {
      var index = path[step];
      var cNode = getVisibleNodeInfoAtIndex({
        treeData: treeData,
        index: index,
        getNodeKey: getNodeKey
      });
      verbosePath = verbosePath + '|' + cNode.node.id;
    }
    verbosePath = verbosePath + '|';
    return verbosePath;
  }

  const handlePassSelectedPath = (path, jobId, customerId) => {
    history.push({pathname: `/job/${jobId}`, state: {path: path + customerId}});
  }

  const changeNode = (node, title) => {
    props.nodeRenamed(node.node.id, node.node.jobId, node.node.type, title);
    handleRefresh();
  }

  const handleInputChange = (event, node, path) => {
    const title = event.target.value;
    const newTreeData = changeNodeAtPath({
      treeData: treeData,
      path,
      getNodeKey: ({treeIndex}) => treeIndex,
      newNode: {...node, title}
    });
  }

  const handleContextMenuClick = (e, treeData, path) => {
    e.preventDefault();
    selectedItem = treeData;

    contextMenu.show({id: "menu_id1", event: e, node: selectedItem});
    //setSelectedTreeNode(treeData.node);

    var lowerLevels = localStorage.getItem("lower-levels");

    if (lowerLevels !== "false" && lowerLevels !== "true") {
      lowerLevels = true;
    }

    if (lowerLevels === "false") {
      lowerLevels = false;
    }

    if (lowerLevels === "true") {
      lowerLevels = true;
    }

    setTimeout(() => {
      var checkbox = document.getElementById('lowerRecords');

      if (checkbox) {
        checkbox.checked = lowerLevels;
      }
    }, 100);
  }

  const handleCanDrop = ({node, nextParent}) => {
    if (node.type == "job" && nextParent && nextParent.type == "vault") {
      return true;
    }

    if (node.type == "job" && nextParent && nextParent.type == "jobs") {
      return true;
    }

    if (nextParent && node.customerId !== nextParent.customerId) {
      return false;
    }

    if (nextParent && (getTreeviewNodeCategory(node.testType) != getTreeviewNodeCategory(nextParent.testType))) {
      return false;
    }

    if (nextParent && (getTreeviewNodeCategory(nextParent.testType) != getTreeviewNodeCategory(node.testType))) {
      return false;
    }

    if (nextParent && (getTreeviewNodeCategory(nextParent.testType) != getTreeviewNodeCategory(nextParent.testType))) {
      return false;
    }

    if (node.type == "test" && nextParent && nextParent.type != "test") {
      return true;
    }

    if (node.type == "tests" && nextParent && nextParent.type != "test") {
      return true;
    }

    if (node.type == 'building' && nextParent && nextParent.type == 'job') {
      return true;
    }

    if (node.type == 'floor' && nextParent && (nextParent.type == 'job' || nextParent.type == 'building')) {
      return true;
    }

    if (node.type == 'room' && nextParent && (nextParent.type == 'job' || nextParent.type == 'building' || nextParent.type == 'floor')) {
      return true;
    }

    if (node.type == 'rack' && nextParent && (nextParent.type == 'job' || nextParent.type == 'building' || nextParent.type == 'floor' || nextParent.type == 'room')) {
      return true;
    }

    if (node.type == 'panel' && nextParent && (nextParent.type == 'job' || nextParent.type == 'building' || nextParent.type == 'floor' || nextParent.type == 'room' || nextParent.type == 'rack')) {
      return true;
    }

    return false;
  }

  const handleNodeExpandedCollapsed = ({treeData, node, expanded, path}) => {
    props.nodeExpanded(node.id, expanded);
  }

  const handleNodeMove = ({
                            node,
                            nextParentNode,
                            prevPath,
                            prevTreeIndex,
                            nextPath,
                            nextTreeIndex,
                            path
                          }) => {

    var selectedNodeId = getSelectedNodeId();
    if (node.type == "test") {
      var jobId = nextParentNode ? nextParentNode.jobId : getJobIdFromNextPath(nextPath, node);
      let testData = node.testData;
      var pathArray = convertPathToVerbose(node, nextPath).split("|");

      var pathLength = pathArray.length;
      var pathToUpdate = pathArray.slice(2, pathLength - 2);
      pathToUpdate = pathToUpdate.filter((item) => item != testData.name);

      const update = (pathToUpdate, test) => {
        for (var i = 0; i < 6; i++) {
          if (pathToUpdate.length > i) {
            test[`level${6 - i}value`] = pathToUpdate[i];
          } else {
            test[`level${6 - i}value`] = null;
          }
        }
      }

      update(pathToUpdate, testData);

      props.moveTest(jobId, [testData], nextParentNode.id);

      if (resetTestCount) {
        resetTestCount();
      }
    }

    if (node.type == "tests") {
      var jobId = nextParentNode ? nextParentNode.jobId : getJobIdFromNextPath(nextPath, node);
      var payload = node.children.map(child => child.testData);

      props.moveTest(jobId, payload, nextParentNode.id);

      if (resetTestCount) {
        resetTestCount();
      }
    }

    if (nextParentNode && nextParentNode.type === 'vault' && node.type === 'job') {
      props.nodeMovedToVault(node.jobId, node.id, true);
    } else if (node.type === 'job' && node.isInVault) {
      props.nodeMovedToVault(node.jobId, node.id, false);
    }

    if (node.type == "building" || node.type == "floor" || node.type == "room" || node.type == "rack" || node.type == "panel") {
      props.nodeMoved(node.id, nextParentNode.id, node.jobId, nextParentNode.jobId, selectedNodeId);
    }

    handleRefresh();
  }

  const handleRefresh = () => {
    if (refresh) {
      setTimeout(() => {
        refresh();
      }, 500);
    }
  }

  const getJobIdFromNextPath = (nextPath, node) => {
    var treeRootNode = getVisibleNodeInfoAtIndex({
      treeData: treeData,
      index: nextPath[0],
      getNodeKey: (node) => {
        node.treeIndex
      }
    });
    var jobNode = jobs.data.filter(job => job.name === treeRootNode.node.title);
    var jobId;
    if (jobNode && jobNode.length == 1 && jobNode[0].id) {
      jobId = jobNode[0].id;
    }
    return jobId;
  }

  const customSearchMethod = ({node, searchQuery}) => {
    return node && node.id === searchQuery.nodeId;
  }

  const {classes} = props;
  return (
    <Fragment>
      {treeData && treeData.length > 0 ?
        <ErrorBoundary>
          <div className={classes.treeViewContainer}>
            <SortableTreeWithoutDndContext
              className={classes.treeView}
              treeData={treeData}
              dndType={"treeview-target"}
              onChange={(treeData, other) => {
                props.treeChange(treeData);
              }}
              onMoveNode={handleNodeMove}
              onVisibilityToggle={handleNodeExpandedCollapsed}
              canDrag={true}
              canDrop={handleCanDrop}
              theme={theme}
              searchQuery={searchQuery}
              searchMethod={customSearchMethod}
              searchFocusOffset={0}
              generateNodeProps={(rowInfo) => ({
                id: (rowInfo.node.jobId),
                title: (
                  <form onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    selectThis(rowInfo.node, rowInfo.path);
                  }}>
                    <input
                      style={{fontSize: "12pt", width: 380, border: "none"}}
                      value={rowInfo && rowInfo.node && rowInfo.node.title && rowInfo.node.type !== 'job' ? rowInfo.node.title : ''}
                      onChange={event => handleInputChange(event, rowInfo.node, rowInfo.path)}
                      onClick={event => console.log(event, "input on click")}
                    />
                    <div style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      top: "4pt",
                      left: "4pt"
                    }}>
                      <span style={{fontSize: "12pt", fontWeight: "normal"}}>
                      {rowInfo && rowInfo.node && rowInfo.node.title && rowInfo.node.type === 'job' ? rowInfo.node.title : ''}
                      </span>
                      <span style={{
                        fontSize: "9pt",
                        fontWeight: "normal",
                        color: "blue"
                      }}>
                      {rowInfo && rowInfo.node && rowInfo.node.title && rowInfo.node.type === 'job' ? ' (' + rowInfo.node.testsCount + ')' : ''}
                      </span>
                    </div>
                  </form>
                ),
                className: (
                  `${rowInfo.node.type} ${rowInfo.node.selected ? "selected" : ""}`
                ),
                buttons: [
                  <div style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: "0",
                    left: "0"
                  }}
                       onContextMenu={(e) => handleContextMenuClick(e, rowInfo)}
                       onClick={(e) => selectThis(rowInfo.node, rowInfo.path)}
                  />
                ]
              })}

            />
          </div>
        </ErrorBoundary>
        :
        <Fragment></Fragment>
      }
      <div>
        <DefaultContextMenu menuId="menu_id1" chooseAction={chooseAction}/>
      </div>
      <Modal/>
      <ConfirmationModal/>
      <NoteModal/>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  treeData: state.treeviewReducer.treeData,
  originalNote: state.treeviewReducer.originalNote,
  tests: state.testsReducer.tests,
  testsCreated: state.testsReducer.testsCreated,
  testUpdated: state.testsReducer.testUpdated,
  testListOf10g: state.testsReducer.testListOf10g,
  scrollTopPostion: state.treeviewReducer.treeViewScrollTopPosition,
  lowerRecordsChecked: state.treeviewReducer.lowerRecordsChecked,
  jobTreeview: state.jobReducer.jobTreeview,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  start: (props) => {
    dispatch(treeview(props));
  },
  jobOrderChange: (field, sort, selectedNodeId, customerId) => {
    dispatch(jobOrderChange(field, sort, selectedNodeId, customerId));
  },
  treeChange: (treeDataToChange) => {
    dispatch(treeviewChange(treeDataToChange));
  },
  moveTest: (jobId, newNodeData, destinationId) => {
    dispatch(moveTestInTree(jobId, newNodeData, destinationId));
  },
  addNodeToTree: (parentId, title, type, jobId, selectedNodeId) => {
    dispatch(treeviewNewNode(parentId, title, type, jobId, selectedNodeId));
  },
  removeNode: (id, jobId, deleteJob) => {
    dispatch(treeviewRemoveNode(id, jobId, deleteJob));
  },
  nodeExpanded: (id, isExpanded) => {
    dispatch(nodeExpanded(id, isExpanded));
  },
  nodeIncludeLowerRecords: (id, includeLowerRecords) => {
    dispatch(nodeIncludeLowerRecords(id, includeLowerRecords));
  },
  nodeRenamed: (nodeId, jobId, type, title) => {
    dispatch(nodeRenamed(nodeId, jobId, type, title));
  },
  nodeMovedToVault: (jobId, nodeId, isInVault) => {
    dispatch(nodeMovedToVault(jobId, nodeId, isInVault));
  },
  nodeMoved: (nodeId, destinationNodeId, jobId, destinationJobId, selectedNodeId) => {
    dispatch(nodeMoved(nodeId, destinationNodeId, jobId, destinationJobId, selectedNodeId));
  },
  getNodeNote: (nodeId) => {
    dispatch(getNodeNote(nodeId));
  },
  addNodeNote: (nodeId, notes) => {
    dispatch(addNodeNote(nodeId, notes));
  },
  lowerRecordsChecked: (checked) => {
    dispatch(lowerRecordsChecked(checked));
  },
  exportJob: (jobId, nodeId, includeLowerRecords, exportCSV) => {
    dispatch(exportJobTreeview(jobId, nodeId, includeLowerRecords, exportCSV));
  },
  notifyError: (message) => {
    dispatch(treeviewNotifyError(message));
  },
  persistSelectedNode: (nodeId) => {
    dispatch(setSelectedNode(nodeId));
  },
  getReportJob: (jobId, nodeId, includeLowerRecords) => {
    dispatch(getJobTreeview(jobId, nodeId, includeLowerRecords));
  },
  resetJobTreeview: () => {
    dispatch(resetJobTreeview());
  },
  setNodeIds: (nodeIds) => {
    dispatch(setNodeIds(nodeIds));
  },
  treeviewEditJobSet: (jobId) => {
    dispatch(treeviewEditJobSet(jobId));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)
(withStyles(styles)(TreeView));

//--rct-color-tree-bg: #f6f8fa; remove colour
// --rct-color-tree-focus-outline: #0366d6; remove colour
